import React, { Fragment, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Breadcrumbs, H3 } from "../../../AbstractElements";
import { Card, CardHeader, Form, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import {
    Company, Email, Localisation, Invoice, Defaults, AddNewCompany, Sheduling, Appearance, System, CustomerAppSettings
} from "../../../Constant/index";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CompanyAdd, getCurrency } from "../../../CommonUrl";
import { toast } from "react-toastify";
import moment from "moment";
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import HandleApiError from "../../Common/ErrorImport/ErrorImport";
import CompanyForm from "./Company";
import LocalisationForm from "./Localization";
import InvoiceForm from "./Invoice";
import DefaultForm from "./Default";
import EmailForm from "./Email";
import ShedulingForm from "./Sheduling";
import AppearanceForm from "./Appearance";
import SystemForm from "./System";
import CustomerApp from "./CustomerApp";

const validationSchema = yup.object().shape({
    email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required"),
    name: yup.string().required("Name is required"),
    phone: yup.string().required("Phone number is required"),
});

const General = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [logo, setLogo] = useState('');
    const [icon, setIcon] = useState('');
    const [IconWithTab, setIconWithTab] = useState('1');
    const form = new FormData();
    const authState = useSelector((state) => state.auth);
    const [financialDate, setFinancialDate] = useState(null);
    const [currencyOptions, setCurrencyOptions] = useState([]);

    useEffect(() => {
        currencyApi();
        const inputElement = document.querySelectorAll('input[type="number"]');
        const preventScrollEvent = (event) => {
            event.preventDefault();
        };
        inputElement.forEach((inputElement) => {
            inputElement.addEventListener('wheel', preventScrollEvent);

        });
    }, []);

    const { register, handleSubmit, setValue, control, formState: { errors }, trigger } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const currencyApi = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, getCurrency);
        if (data.status === true) {
            const transformedData = data.data.map((item) => ({
                label: item.name,
                value: item.code
            }));
            setCurrencyOptions(transformedData);
        } else {
            HandleApiError(response.status)
        }
    };

    const handleChangeDate = date => {
        setFinancialDate(date);
    };

    const handleLogoChange = (event) => {
        const selectedFile = event.target.files[0];
        setLogo(selectedFile);
    };

    const handleIconChange = (event) => {
        const selectedFile = event.target.files[0];
        setIcon(selectedFile);
    };

    const nextTab = async () => {
        const isValid = await trigger()
        if (isValid) {
            const nextTab = String(Number(IconWithTab) + 1);
            if (nextTab <= '9') {
                setIconWithTab(nextTab)
            }
        }
    }

    const onSubmit = async (data) => {
        const countryCode = data.countryCode;
        const mobile = data.phone;
        if (mobile && countryCode) {
            setLoading(true)
            const phoneno = mobile.slice(countryCode.length)
            form.append("name", data.name);
            form.append("email", data.email);
            form.append("phone", phoneno);
            form.append("country_code", countryCode);
            form.append("address", data.address || "");
            form.append("tax_in", data.taxin);
            if (data.logo) {
                form.append("logo", data.logo[0]);
            }
            if (data.financialDate) {
                const formattedFinancialDate = moment(data.financialDate).format("DD-MM-YYYY");
                form.append("financial_year", formattedFinancialDate);
            }
            form.append("financial_year", data?.financial || "");
            form.append("time_zone", data?.timezone?.value || "");
            form.append("date_format", data.dateFormate?.value || "");
            form.append("separator", data.separator?.value || "");
            form.append("position", data.position?.value || "");
            form.append("decimal", data.decimal?.value || "");
            form.append("item_name", data.Itemname?.value || "");
            form.append("price_name", data.pricename?.value || "");
            form.append("quantity_name", data.quantityname?.value || "");
            form.append("invoice_prefix", data.invprefix || "");
            form.append("invoice_suffix", data.invsuffix || "");
            form.append("due_date", data.duedate?.value || "");
            if (data.icon) {
                form.append("icon", data.icon[0]);
            }

            form.append("currency", data.currency?.value || "");
            form.append("language", data.language?.value || "");
            const postResponce = await postClientUrlWithToken(
                authState.apiUrl,
                CompanyAdd,
                form,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (postResponce.status === 200) {
                if (postResponce.data.status === true) {
                    toast.success(postResponce.data.message);
                    navigate(`/subscriptionAddition`, { state: { id: postResponce.data.data.id } });
                } else {
                    if (Array.isArray(postResponce.data.message)) {
                        postResponce.data.map((e) => { e.message })
                    } else {
                        toast.error(postResponce.data.message);
                    }
                    setLoading(false)
                }
            } else if (postResponce.status >= 400 && postResponce.status <= 405) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
            } else if (postResponce.status >= 500 && postResponce.status <= 505) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
            } else {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
            }
        }

    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <Breadcrumbs mainTitle={AddNewCompany} parent="Company" title={AddNewCompany} />
                <Card className="tab-company-edit">
                    <Nav className="nav-primary" tabs>
                        <NavItem >
                            <NavLink className={IconWithTab === '1' ? 'active' : ''} onClick={() => setIconWithTab('1')}><span className="fs-6 fw-bold cursor ">{Company}</span></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={IconWithTab === '2' ? 'active' : ''} onClick={() => setIconWithTab('2')}><span className="fs-6 fw-bold cursor">{Localisation}</span></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={IconWithTab === '3' ? 'active' : ''} onClick={() => setIconWithTab('3')}><span className="fs-6 fw-bold cursor">{Invoice}</span></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={IconWithTab === '4' ? 'active' : ''} onClick={() => setIconWithTab('4')}><span className="fs-6 fw-bold cursor">{Defaults}</span></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={IconWithTab === '5' ? 'active' : ''} onClick={() => setIconWithTab('5')}><span className="fs-6 fw-bold cursor">{Email}</span></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={IconWithTab === '6' ? 'active' : ''} onClick={() => setIconWithTab('6')}><span className="fs-6 fw-bold cursor">{Sheduling}</span></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={IconWithTab === '7' ? 'active' : ''} onClick={() => setIconWithTab('7')}><span className="fs-6 fw-bold cursor">{Appearance}</span></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={IconWithTab === '8' ? 'active' : ''} onClick={() => setIconWithTab('8')}><span className="fs-6 fw-bold cursor">{System}</span></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={IconWithTab === '9' ? 'active' : ''} onClick={() => setIconWithTab('9')}><span className="fs-6 fw-bold cursor">{CustomerAppSettings}</span></NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={IconWithTab}>

                        <TabPane className="fade show" tabId="1">
                            <CardHeader className="pb-0">
                                <H3>{Company}</H3>
                                <CompanyForm register = {register} control = {control}/>
                            </CardHeader>
                        </TabPane>

                        <TabPane tabId="2">
                            <CardHeader className="card-text-color pb-0">
                                <H3>{Localisation}</H3>
                            </CardHeader>
                        <LocalisationForm register = {register} control = {control}/>
                        </TabPane>

                        <TabPane tabId="3">

                            <CardHeader className="card-text-color pb-0">
                                <H3>{Invoice}</H3>
                            </CardHeader>
                                <InvoiceForm register = {register} control = {control}/>
                        </TabPane>

                        <TabPane tabId="4">
                            <CardHeader className="card-text-color pb-0">
                                <H3>{Defaults}</H3>
                            </CardHeader>
                            <DefaultForm register = {register} control = {control}/>
                            
                        </TabPane>
                        <TabPane tabId="5">
                            <CardHeader className="card-text-color pb-0">
                                <H3>{Email}</H3>
                            </CardHeader>
                            <EmailForm register = {register} control = {control}/>
                            
                        </TabPane>
                        <TabPane tabId="6">
                            <CardHeader className="card-text-color pb-0">
                                <H3>{Sheduling}</H3>
                            </CardHeader>
                            <ShedulingForm register = {register} control = {control}/>
                            
                        </TabPane>
                        <TabPane tabId="7">
                            <CardHeader className="card-text-color pb-0">
                                <H3>{Appearance}</H3>
                            </CardHeader>
                            <AppearanceForm register = {register} control = {control}/>
                            
                        </TabPane>
                        <TabPane tabId="8">
                            <CardHeader className="card-text-color pb-0">
                                <H3>{System}</H3>
                            </CardHeader>
                            <SystemForm register = {register} control = {control}/>
                            
                        </TabPane>
                        <TabPane tabId="9">
                            <CardHeader className="card-text-color pb-0">
                                <H3>{CustomerAppSettings}</H3>
                            </CardHeader>
                            <CustomerApp register = {register} control = {control}/>
                            
                        </TabPane>
                    </TabContent>
                </Card>
            </Form>
        </Fragment>
    );
};

export default General;
